/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RoleTypeDTO,
    RoleTypeDTOFromJSON,
    RoleTypeDTOFromJSONTyped,
    RoleTypeDTOToJSON,
} from './RoleTypeDTO';

/**
 * 
 * @export
 * @interface RoleDTO
 */
export interface RoleDTO {
    /**
     * 
     * @type {RoleTypeDTO}
     * @memberof RoleDTO
     */
    authority?: RoleTypeDTO;
}

export function RoleDTOFromJSON(json: any): RoleDTO {
    return RoleDTOFromJSONTyped(json, false);
}

export function RoleDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'authority': !exists(json, 'authority') ? undefined : RoleTypeDTOFromJSON(json['authority']),
    };
}

export function RoleDTOToJSON(value?: RoleDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'authority': RoleTypeDTOToJSON(value.authority),
    };
}

